export const SINGLE_PANE_WIDTH = 225;
export const DOUBLE_PANE_WIDTH = 454;

export const SNAPSHOT_CONTENT = {
  ACCOMMODATION: 'Accommodation',
  FEES: 'Fees',
  CARE_FEES: 'Care Fees',
  OCCUPANCIES: 'Occupancies',
  SHOP_NOTES: 'Shop Notes',
  FILES: 'Files',
};

export const SNAPSHOT_MODAL_STEP = {
  DEFAULT: 0,
  EDITOR: 1,
  DATA: 2,
};

export const SNAPSHOT_STATUS = {
  CURRENT: 1,
  HISTORICAL: 2,
  DRAFT: 3,
};

export const SNAPSHOT_STATUS_LABELS: { [key: number]: string } = {
  [SNAPSHOT_STATUS.CURRENT]: 'current',
  [SNAPSHOT_STATUS.HISTORICAL]: 'historical',
  [SNAPSHOT_STATUS.DRAFT]: 'draft',
};
